import { HEADER_HEIGHT, MAIN_THEME } from '@styles';

import { makeStyles } from 'tss-react/mui';

export const useDynamicFormDrawerStyles = makeStyles()({
  drawer: {
    width: 450,
    minWidth: 300,
    maxHeight: '100%',
    overflowY: 'auto',
    left: 'unset !important',
    right: '!important',
    '@media only screen and (min-height: 400px)': {
      minHeight: 200
    }
  },
  drawerHeader: {
    background: MAIN_THEME.color.red,
    height: HEADER_HEIGHT,
    minHeight: HEADER_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between !important',
    overflow: 'hidden'
  },
  drawerHeaderTitle: {
    color: 'rgba(255, 255, 255, 1)',
    fontFamily: MAIN_THEME.font.regular,
    fontSize: MAIN_THEME.fontSize.rg,
    lineHeight: '19px',
    margin: '0',
    fontWeight: 'bold'
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    minHeight: '200px'
  },
  drawerContent: {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    minHeight: '200px',
    padding: '20px 15px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  section: {
    marginBottom: '25px'
  },
  sectionFigure: {
    height: '20px',
    width: '20px',
    margin: '0px 0 0 30px',
    background:
      "url('https://ufa-cdn.baibars.club/ufa-app-portal/images/app-launcher.svg')",
    backgroundSize: '20px 20px',
    backgroundRepeat: 'no-repeat'
  },
  sectionTitle: {
    fontFamily: MAIN_THEME.font.bold,
    lineHeight: '18px',
    height: '50px'
  },
  sectionTitleText: {
    margin: '0',
    fontSize: MAIN_THEME.fontSize.md
  },
  sectionTitleLine: {
    margin: '10px 0 5px 0',
    opacity: '0.25'
  },
  note: {
    color: MAIN_THEME.color.red,
    fontSize: MAIN_THEME.fontSize.sm,
    fontStyle: 'italic',
    margin: 0,
    marginBottom: '15px',
    textWrap: 'pretty'
  },
  submitButton: {
    margin: '0 auto 25px auto!important',
    display: 'flex !important'
  },
  submitButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }
});
